"use strict";

define('components/filter_bar/filters/tag_filters',['components/tags'], function(Tags) {
    var tagFiltersComponent = {
        initWithContext: function(context) {
            // TODO: Remove dependence on tableFilterBarComponent
            // The dependency is required due for now due to the Tags
            // component needing tableInstance.
            var tagsInstance = new Tags();
            tagsInstance.initButtonBar(context.tableFilterBarData.tableInstance);

            context.tagFiltersData = {
                tagsInstance: tagsInstance
            };
        }
    };

    return tagFiltersComponent;
});

